import React, { PureComponent } from 'react';
import { throttle } from 'lodash';
import { scroller } from 'react-scroll';

class FormNavigation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
    };
    this.checkSection = this.checkSection.bind(this);
  }
  componentDidMount() {
    this.scrollListener = window.addEventListener('scroll', throttle(this.checkSection, 300));
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkSection);
  }
  checkSection() {
    [...this.props.sections].reverse().forEach((section) => {
      if (!this[section]) {
        return false;
      }
      const { top, bottom } = document.getElementById(`root_${section}`).getBoundingClientRect();

      if (top >= 0 && bottom <= window.scrollY + window.innerHeight) {
        this.setState({ active: this.props.sections.indexOf(section) });
      }
      return true;
    });
  }
  render() {
    const getClassesLinks = (section, index) => {
      if (index === this.state.active) {
        return ' active';
      }
      return '';
    };
    return (
      <div className="form-navigation-wrapper">
        <div className="form-floating-panel-container">
          <div className="floating-form-panel-contents">
            {this.props.sections.map(
              (section, index) =>
                (<div
                  ref={(el) => { this[section] = el; }}
                  role="presentation"
                  className={`form-section-link${getClassesLinks(section, index)}`}
                  key={section}
                  onClick={() => {
                    scroller.scrollTo(`root_${section}`, {
                      duration: 800,
                      delay: 0,
                      smooth: 'easeInOutQuart',
                    });
                    this.setState({ active: this.props.sections.indexOf(section) });
                  }}
                >
                  {this.props.jsonSchema.properties[section].title}
                </div>),
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FormNavigation;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/formNavigation.js